<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <div class="modal-card">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">
          Update Reporting Responsible
        </h1>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column">
            <b-field label="Reporting Responsible">
              <b-select
                name="reporting_responsible"
                expanded
                v-model="reporting_responsible"
                placeholder="Please select"
                data-cy="reporting-responsible"
              >
                <option selected></option>
                <option
                  v-for="(option, index) in users"
                  :value="option.id"
                  :key="index"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button slot="right" type="is-primary" @click="submit">
          Assign user
        </b-button>
        <b-button slot="right" type="is-danger" @click="cancel">
          Abort
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>
<script>
import ReportingTrackerDataService from "../../services/ReportingTrackerDataService";
import UserDataService from "../../services/UserDataService";
import UsersMixin from "@/mixins/usersMixin";
// @group Reporting Tracker
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    checkedRows: {
      type: Array,
      default: null
    },
    filters: {
      type: String,
      default: null
    },
    checkedAll: {
      type: Boolean,
      default: null
    },
    users: {
      type: Array,
      default: null
    },
    mixins: [UsersMixin]
  },
  data() {
    return {
      reporting_responsible: null,
      isModalActive: false,
      reportingTrackerService: new ReportingTrackerDataService(),
      userDataService: new UserDataService()
    };
  },

  methods: {
    handleApiError(reason) {
      let errorMessage = reason.response.data["detail"];

      if (errorMessage == null || errorMessage == undefined) {
        errorMessage = "Invalid input";
      }
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
      });
    },
    submit() {
      if (this.reporting_responsible != null) {
        this.reportingTrackerService
          .bulkUpdateReportingResponsible(
            this.checkedRows.map(records => records.id),
            this.filters,
            this.reporting_responsible,
            this.checkedAll
          )
          .subscribe(response => {
            if (response["error"]) {
              this.$buefy.dialog.alert({
                title: "Error",
                message: response["error"]
              });
              return false;
            } else {
              this.$buefy.dialog.alert({
                title: "Success",
                message: "Reporting Responsible Updated!"
              });
              this.$emit("viewConfirm", this.reporting_responsible);
            }
          }, this.handleApiError);
      } else {
        this.$buefy.dialog.alert({
          title: "Error",
          message: "Please select user from the list!",
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },
    cancel() {
      this.$emit("cancel");
    }
  },
  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  }
};
</script>
